/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box } from './styles';

const BoxContainer = ({ children }: any) => {
  return <Box>{children}</Box>;
};
export default BoxContainer;
